import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import WearableActivitySummaryQuery from './WearableActivitySummaryQuery';

export interface WearableActivitySummary {
  date: string;
  provider: string;
  device: string | null;
  steps: number | null;
  distanceMeters: number | null;
  floorsClimbed: number | null;
  elevationMeters: number | null;
  activeCaloriesKcal: number | null;
  totalCaloriesKcal: number | null;
  activeMinutes: number | null;
  sedentaryMinutes: number | null;
  lightIntensityMinutes: number | null;
  moderateIntensityMinutes: number | null;
  vigorousIntensityMinutes: number | null;
  heartRateAvgBpm: number | null;
  heartRateMaxBpm: number | null;
  heartRateMinBpm: number | null;
}

export interface WearableActivitySummaryResult {
  loading: boolean;
  activitySummary: WearableActivitySummary[];
  error: ApolloError | undefined;
  refetch: () => Promise<unknown>;
}

interface Props {
  dateFrom: string;
  dateTo: string;
  children: (result: WearableActivitySummaryResult) => React.ReactElement;
}

const WearableActivitySummaryConnectorApollo: React.FC<Props> = ({
  dateFrom,
  dateTo,
  children,
}) => {
  const { loading, data, error, refetch } = useQuery(WearableActivitySummaryQuery, {
    variables: { dateFrom, dateTo },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });

  return children({
    loading,
    activitySummary: data?.wearable?.activitySummary ?? [],
    error,
    refetch,
  });
};

export default WearableActivitySummaryConnectorApollo;
